// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__sp4bb","logo":"Header_logo__e1dpu","search":"Header_search__s2G-Z"};